module.exports = __webpack_public_path__ + "static/img/Joshua-Reichelt.911b961.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Joshua-Reichelt.jpg
// module id = 80Av
// module chunks = 0